import { render, staticRenderFns } from "./InstagramDialog.vue?vue&type=template&id=22a4e20e&scoped=true"
import script from "./InstagramDialog.vue?vue&type=script&lang=js"
export * from "./InstagramDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a4e20e",
  null
  
)

export default component.exports